function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.60307 6.90202C7.80305 7.10199 8.12727 7.10199 8.32724 6.90202L11.586 3.64327C11.786 3.4433 11.786 3.11908 11.586 2.9191C11.386 2.71913 11.0618 2.71913 10.8618 2.9191L8.47722 5.30371L8.47722 0.778989C8.47722 0.496185 8.24796 0.266927 7.96516 0.266926C7.68235 0.266927 7.4531 0.496184 7.4531 0.77899L7.45309 5.30371L5.06849 2.9191C4.86852 2.71913 4.5443 2.71913 4.34433 2.9191C4.14435 3.11907 4.14435 3.44329 4.34433 3.64327L7.60307 6.90202ZM8.36925 9.1478C8.16928 8.94783 7.84505 8.94783 7.64508 9.1478L4.38633 12.4065C4.18636 12.6065 4.18636 12.9307 4.38633 13.1307C4.5863 13.3307 4.91053 13.3307 5.1105 13.1307L7.4951 10.7461L7.4951 15.2708C7.4951 15.5536 7.72436 15.7829 8.00716 15.7829C8.28997 15.7829 8.51923 15.5536 8.51923 15.2708L8.51923 10.7461L10.9038 13.1307C11.1038 13.3307 11.428 13.3307 11.628 13.1307C11.828 12.9307 11.828 12.6065 11.628 12.4066L8.36925 9.1478Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "currentColor"
})));

var SvgIcReduce = function SvgIcReduce(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcReduce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_reduce.4f66fb9c.svg";
export { ForwardRef as ReactComponent };